import { render, staticRenderFns } from "./VSettingsOptions.vue?vue&type=template&id=1402f884&"
import script from "./VSettingsOptions.vue?vue&type=script&lang=js&"
export * from "./VSettingsOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports